<template>
  <div>
    <h2 class="text-left alert" :class="[removed ? 'alert-danger' : 'alert-success']">
      Farms
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[removed ? 'glyphicon-plus' : 'glyphicon-remove']"></span>
      </a>
    </h2>
    <template v-if="!removed">
      <div v-for="farm in model.FARMS" :key="`farm_data-${farm.id}`">
        <subsection :title="farm.farm_label" :step-name="stepName" :subsection="`farm_${farm.id}-farm_details`">
          <report-comment
            :field_name="`farm_${farm.id}-heading_farm_detail_label`"
            :model="model.COMMENTS"
            :heading="true"
          >
          </report-comment>

          <div class="row">
            <div class="col-md-6">
              <dl class="dl-horizontal">
                <dt>Supply</dt>
                <dd>{{ model[`farm_${farm.id}-supply_number`] || '-' }}</dd>

                <dt>Farm Name</dt>
                <dd>{{ model[`farm_${farm.id}-farm_name`] || '-' }}</dd>

                <dt>Farm Area (ha)</dt>
                <dd>{{ model[`farm_${farm.id}-farm_area_ha`] || '-' }}</dd>

                <dt>Shed Type</dt>
                <dd>{{ model[`farm_${farm.id}-shed_type`] || '-' }}</dd>

                <dt>Bales</dt>
                <dd>{{ model[`farm_${farm.id}-shed_bales`] || '-' }}</dd>

                <dt>Shed Address</dt>
                <dd>{{ model[`farm_${farm.id}-shed_address`] || '-' }}</dd>

                <dt>NAIT</dt>
                <dd>{{ model[`farm_${farm.id}-nait`] || '-' }}</dd>

                <dt>LIC</dt>
                <dd>{{ model[`farm_${farm.id}-lic_code`] || '-' }}</dd>

                <dt>Dairy rumination technology?</dt>
                <dd>{{ model[`farm_${farm.id}-rumination_tech_choice`] || '-' }}</dd>

                <dt>Additional Information</dt>
                <dd>{{ model[`farm_${farm.id}-rumination_tech_details`] || '-' }}</dd>
              </dl>
            </div>
          </div>
        </subsection>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'FarmDetails',
  mixins: [mixin],
}
</script>
